import styled from "styled-components";

export const FiltersWrapper = styled.div``;

export const FiltersForm = styled.form`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
`;

export const FilterFormActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
`;